<template>
    <td
        v-if="freeSpace"
        style="background-color: #f8f8f8; border: none; padding: 5px"
    ></td>
    <td
        v-else
        class="table-cell md:table-cell"
        :class="
            `${breakpoint} ${noBorderBottom ? 'no-border-bottom' : ''} ${
                allBorders ? 'all-borders' : ''
            }`
        "
    >
        <div class="table-data">
            <slot></slot>
        </div>
    </td>
</template>

<script>
export default {
    props: {
        breakpoint: {
            type: String,
            default: 'md'
        },
        noBorderBottom: {
            type: Boolean,
            default: false
        },
        freeSpace: {
            type: Boolean,
            defaallBorders1ult: false
        },
        allBorders: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
@import '../../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';

@mixin tableCellMixin($breakpoint) {
    &.select-row-enabled {
        @include media-breakpoint-up($breakpoint) {
            padding-left: inherit !important;
        }
    }
    @include media-breakpoint-up($breakpoint) {
        display: table-cell;
        width: auto;
        padding-top: 1rem;
        padding-bottom: 1rem;
    }
}

@mixin tableRowMixin($breakpoint) {
    @include media-breakpoint-up($breakpoint) {
        .row-select {
            position: static;
        }
        td {
            border-bottom: 1px solid var(--color-gray-300);
            &.no-border-bottom {
                border-bottom: none;
            }
            &:first-child {
                border-left: 1px solid var(--color-gray-300);
            }
            &:last-child {
                border-right: 1px solid var(--color-gray-300);
            }
            &.all-borders {
                border-top: 1px solid var(--color-gray-300);
                &:first-child {
                    border-top-left-radius: 0.2rem;
                    border-bottom-left-radius: 0.2rem;
                }
                &:last-child {
                    border-top-right-radius: 0.2rem;
                    border-bottom-right-radius: 0.2rem;
                }
            }
        }
        &:first-child {
            td {
                border-top: 1px solid var(--color-gray-300);
                &:first-child {
                    border-top-left-radius: 0.2rem;
                }
                &:last-child {
                    border-top-right-radius: 0.2rem;
                }
            }
        }
        &.bottom-rounded {
            td {
                border-bottom: 1px solid var(--color-gray-300);
                &:first-child {
                    border-bottom-left-radius: 0.2rem;
                }
                &:last-child {
                    border-bottom-right-radius: 0.2rem;
                }
            }
        }
    }
}
.ui-data-table {
    tr {
        .table-hidden-td {
            display: none !important;
        }
        .action-td {
            .table-data {
                display: flex;
                justify-content: flex-end;
            }
        }
        .row-select {
            position: absolute;
        }

        .table-data {
            justify-content: space-between;
            .td-value {
                overflow-wrap: anywhere;
            }
        }

        &.md {
            @include tableRowMixin(md);
        }
        &.lg {
            @include tableRowMixin(lg);
        }

        td.table-cell {
            display: block;
            width: 100%;
            color: var(--color-dark);
            border-top: none;
            vertical-align: middle;
            padding-left: 1rem;
            padding-right: 1rem;
            padding-bottom: 0.5rem;
            padding-top: 0.5rem;
            &.empty {
                padding: 0 !important;
            }
            &.select-row-enabled {
                padding-left: 2.5rem !important;
                &:first-of-type {
                    padding-left: 0 !important;
                }
            }
            &.md {
                @include tableCellMixin(md);
            }
            &.lg {
                @include tableCellMixin(lg);
            }
        }
    }
}
</style>
